// ============================================================
// BrutFourni — « le client fournit le brut », en une ligne. 6 octobre 2026.
// ------------------------------------------------------------
// Philippe coche « matière fournie par le client » : le client envoie
// son propre brut, que le plan ne décrit pas. Le bloc brut restait
// incomplet — la lecture n'avait pas de quoi le déduire — et l'estimation
// plantait (devis 2026-10-010).
//
// Une ligne : la forme et les cotes du brut REÇU, saisies. Elles
// alimentent les mêmes `raw_*` que le bloc brut — une seule porte par
// valeur — et portent la provenance « saisi ».
// ============================================================

import { useEffect, useState } from 'react';
import NumberField from '../../ui/NumberField.jsx';
import { FORMES_RONDES } from '@shared/brut.js';

const ok = (v) => v != null && v !== '' && Number(v) > 0;

/** Le brut retenu est-il incomplet ? Même règle que le serveur (`brutManquant`). */
export function brutIncomplet(piece) {
  const champs = FORMES_RONDES.includes(piece.raw_shape)
    ? ['raw_diameter', 'raw_length'] : ['raw_l', 'raw_w', 'raw_h'];
  return champs.some((k) => !ok(piece[k]));
}

/**
 * Le mode s'ALLUME quand la matière est fournie et le brut incomplet, et
 * ne s'éteint qu'en décochant : il ne doit pas disparaître sous les doigts
 * à la dernière cote tapée.
 */
export function useModeBrutFourni(piece) {
  const fournie = piece.matiere_fournie_client === true;
  const [actif, setActif] = useState(() => fournie && brutIncomplet(piece));
  const incomplet = brutIncomplet(piece);
  useEffect(() => {
    if (!fournie) setActif(false);
    else if (incomplet) setActif(true);
  }, [fournie, incomplet]);
  return actif;
}

/** `forme` : LE sélecteur de `PreChiffrage` — un seul écran porte le choix de forme (§3.7). */
export default function BrutFourni({ piece, disabled, onChange, forme }) {
  const ronde = FORMES_RONDES.includes(piece.raw_shape);
  const cotes = ronde
    ? [['raw_diameter', 'Ø'], ['raw_length', 'Longueur']]
    : [['raw_l', 'Longueur'], ['raw_w', 'Largeur'], ['raw_h', 'Épaisseur']];
  return (
    <div className="brut-fourni">
      <p className="caps">Brut fourni par le client</p>
      <div className="brut-fourni__ligne">
        {forme}
        {cotes.map(([clef, label]) => (
          <NumberField
            key={clef} label={label} unit="mm" min={0} source="saisi"
            value={piece[clef]} disabled={disabled}
            onChange={(v) => onChange({ [clef]: v })}
          />
        ))}
      </div>
      <p className="field__hint">
        Les cotes du brut que vous recevez : elles servent au volume de copeaux, la matière n’est pas facturée.
      </p>
    </div>
  );
}
